export default "__VITE_ASSET__CcHeeJWd__"